import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Arquivo from '../../../../components/auth/partido/listar/form_arquivo'


function ArquivoPartidoScreen() {

    return (
        <Fragment>
            <Head titulo="Substituindo Arquivo - Liberação de Recursos" />
            <HeaderLogged />
            <Container>
               <Arquivo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ArquivoPartidoScreen;